import React, {useState, useEffect, useCallback, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import FullBodyContentView from '../../views/fullBodyContentView';
import ConfigurationSummary from './config-summary';

function ConfigSummary({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onLeft = useCallback(() => {
    onComponent(<ConfigurationSummary />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;
    onLeft();
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands({onLeft});
  }, [onLeft]);

  return (
    <FullBodyContentView
      title="Configuration Summary"
      fullCaption="Time......................[special]..............
      Time Zone.............greenwich..........
      Date......................[special]..............
      Tag.......................0x19, 0x4B..........
      Mass Flow Unit.....gram/s................
      Volume Flow Unit......L/s.......... 
      "
    />
  );
}

export default ConfigSummary;
